<app-pet-rehome-modal-header></app-pet-rehome-modal-header>

<div *ngIf="!submissionComplete">
  <div class="modal-body">
    <div class="row mt-2">
      <div class="col-12">
        <p>
          Thank you for your transfer of keepership request.
        </p>
        <p>
          Please note there is a transfer of keepership processing charge payable prior to submitting your request.
        </p>
        <p>
          Once the payment is received we will run security checks on the microchip and seek
          permission from the current registered keeper to relinquish keepership. Once we have
          permission, we then update the database to ensure all details are transferred and are
          correct as per the requirements. You will also receive the benefit of our identialert
          membership, the UK’s most comprehensive stolen and missing pet reunifications services
          for 12 months.
        </p>
        <div class="mb-3 text-center">
          <label class="form-check-label d-flex align-items-center">
            <input
              class="terms-checkbox me-3"
              id="acceptTerms"
              name="acceptTerms"
              [(ngModel)]="acceptTerms"
              type="checkbox"
              required>
              <a routerLink="/terms-and-conditions" target="_blank">
                <small>
                  I agree to identibase’s terms and conditions
                  <fa-icon
                    class="ms-1"
                    [icon]="['fas', 'external-link-alt']">
                  </fa-icon>
                </small>
              </a>
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-light" ngbAutofocus (click)="activeModal.dismiss()">
      No, go back
    </button>
    <button type="button" class="btn btn-primary" (click)="confirmAndProceedToCheckout()" [disabled]="!acceptTerms || stripeDetailsLoading">
      <fa-icon *ngIf="stripeDetailsLoading" [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-3"></fa-icon>
      Yes, continue
    </button>
  </div>
</div>
